// @flow
import { UserInfotoolsActionTypes } from './constants';

type UserInfotoolsAction = { type: string, payload: {} | string };

// common success
export const userInfotoolsApiResponseSuccess = (actionType: string, data: any): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const userInfotoolsApiResponseError = (actionType: string, error: string): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getUserInfotools = (id: string): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.GET_USER_INFOTOOLS,
    payload: { id },
});

export const addUserInfotools = (user: any): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.ADD_USER_INFOTOOLS,
    payload: user
})
export const updateUserInfotools = (user: any): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS,
    payload: user
})
export const deleteUserInfotools = (id: string): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS,
    payload: { id }
})

export const listUsersInfotools = (params: any): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS,
    payload: params,
});


export const resetUsersInfotools = (): UserInfotoolsAction => ({
    type: UserInfotoolsActionTypes.RESET,
    payload: {},
});

